module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/venue_tvb-0a03998898936886430d56d5ce72fdbb.jpg";